import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";
import { TitleService } from "@app/services/title.service";

@Component({
    selector: "app-blog-page",
    templateUrl: "./blog-page.component.html",
    styleUrls: ["./blog-page.component.scss"],
})
export class BlogPageComponent implements OnInit {
    private destroyRef = inject(DestroyRef);

    constructor(
        private route: ActivatedRoute,
        private titleService: TitleService,
    ) {}

    ngOnInit(): void {
        this.route.data
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data) => {
                switch (data.kind) {
                    case "CoP": {
                        this.pageTitleArea = [
                            {
                                title: "Community of Practice",
                            },
                        ];
                        this.singleBlogPost = [
                            {
                                postImg: "assets/img/gallery/img1.jpg",
                                postTitle: "What is a Community of Practice?",
                                postSubTitle: "",
                                postLink: "what-is-CoP",
                                postDate: "April 30, 2020",
                                postAuthorImage: "assets/img/user1.jpg",
                                postAuthorName: "Alex Morgan",
                            },
                            {
                                postImg: "assets/img/gallery/img3.jpg",
                                postTitle:
                                    "Benefits of Communities of Practice",
                                postSubTitle: "",
                                postLink: "benefits-CoP",
                                postDate: "April 28, 2020",
                                postAuthorImage: "assets/img/user2.jpg",
                                postAuthorName: "Sarah Taylor",
                            },
                            {
                                postImg: "assets/img/gallery/img8.jpg",
                                postTitle:
                                    "Community of Practice Roles and Responsibilities",
                                postSubTitle: "",
                                postLink: "CoP-Roles",
                                postDate: "April 27, 2020",
                                postAuthorImage: "assets/img/user3.jpg",
                                postAuthorName: "David Warner",
                            },
                            {
                                postImg: "assets/img/blog/UDF-CoP-Banner.png",
                                postTitle: "UDF Community of Practice (CoP)",
                                postSubTitle: "",
                                postLink: "UDF-CoP",
                                postDate: "April 30, 2020",
                                postAuthorImage: "assets/img/user1.jpg",
                                postAuthorName: "Alex Morgan",
                            },
                        ];
                        break;
                    }
                    case "newsletters": {
                        this.pageTitleArea = [
                            {
                                title: "Newsletters",
                            },
                        ];
                        this.singleBlogPost = [
                            {
                                postImg: "assets/img/blog/Newsletter1.png",
                                postTitle:
                                    "New Dashboard tracks key metrics about Upstream Data Products",
                                postSubTitle: "Newsletter #1",
                                postLink: "CoP-Newsletter1",
                                postDate: "April 30, 2020",
                                postAuthorImage: "assets/img/user1.jpg",
                                postAuthorName: "Alex Morgan",
                            },
                            {
                                postImg: "assets/img/blog/Newletter2.png",
                                postTitle:
                                    "New workflow tool makes proposing new Upstream business glossary terms easy",
                                postSubTitle: "Newsletter #2",
                                postLink: "CoP-Newsletter2",
                                postDate: "April 28, 2020",
                                postAuthorImage: "assets/img/user2.jpg",
                                postAuthorName: "Sarah Taylor",
                            },
                            {
                                postImg: "assets/img/blog/Newsletter3.png",
                                postTitle:
                                    "Conceptual Data Model Dashboard is released",
                                postSubTitle: "Newsletter #3",
                                postLink: "CoP-Newsletter3",
                                postDate: "April 28, 2020",
                                postAuthorImage: "assets/img/user2.jpg",
                                postAuthorName: "Sarah Taylor",
                            },
                        ];
                        break;
                    }
                }
            });

        this.titleService.setTitle("CoP");
    }

    pageTitleArea: pageTitle[] = [
        {
            title: "Community of Practice",
        },
    ];
    singleBlogPost: blogPostContent[] = [
        {
            postImg: "assets/img/gallery/img1.jpg",
            postTitle: "What is a Community of Practice?",
            postSubTitle: "",
            postLink: "what-is-CoP",
            postDate: "April 30, 2020",
            postAuthorImage: "assets/img/user1.jpg",
            postAuthorName: "Alex Morgan",
        },
        {
            postImg: "assets/img/gallery/img3.jpg",
            postTitle: "Benefits of Communities of Practice",
            postSubTitle: "",
            postLink: "benefits-CoP",
            postDate: "April 28, 2020",
            postAuthorImage: "assets/img/user2.jpg",
            postAuthorName: "Sarah Taylor",
        },
        {
            postImg: "assets/img/gallery/img8.jpg",
            postTitle: "Community of Practice Roles and Responsibilities",
            postSubTitle: "",
            postLink: "CoP-Roles",
            postDate: "April 27, 2020",
            postAuthorImage: "assets/img/user3.jpg",
            postAuthorName: "David Warner",
        },
        {
            postImg: "assets/img/blog/UDF-CoP.jpg",
            postTitle: "UDF Community of Practice (CoP)",
            postSubTitle: "",
            postLink: "UDF-CoP",
            postDate: "April 30, 2020",
            postAuthorImage: "assets/img/user1.jpg",
            postAuthorName: "Alex Morgan",
        },
        // {
        //     postImg: 'assets/img/blog/img8.jpg',
        //     postTitle: 'Finding the blocks of neighboring fields',
        //     postLink: 'blog-details',
        //     postDate: 'April 28, 2020',
        //     postAuthorImage: 'assets/img/user2.jpg',
        //     postAuthorName: 'Sarah Taylor'
        // },
        // {
        //     postImg: 'assets/img/blog/img9.jpg',
        //     postTitle: 'Data into Your Enterprise to Drive Insights',
        //     postLink: 'blog-details',
        //     postDate: 'April 27, 2020',
        //     postAuthorImage: 'assets/img/user3.jpg',
        //     postAuthorName: 'David Warner'
        // },
        // {
        //     postImg: 'assets/img/blog/img10.jpg',
        //     postTitle: 'Introduction to Recommendation Engines',
        //     postLink: 'blog-details',
        //     postDate: 'April 30, 2020',
        //     postAuthorImage: 'assets/img/user1.jpg',
        //     postAuthorName: 'Alex Morgan'
        // },
        // {
        //     postImg: 'assets/img/blog/img11.jpg',
        //     postTitle: '5 Things You Should Know About Data',
        //     postLink: 'blog-details',
        //     postDate: 'April 28, 2020',
        //     postAuthorImage: 'assets/img/user2.jpg',
        //     postAuthorName: 'Sarah Taylor'
        // },
        // {
        //     postImg: 'assets/img/blog/img12.jpg',
        //     postTitle: 'Which Language to Choose for Deep Learning?',
        //     postLink: 'blog-details',
        //     postDate: 'April 27, 2020',
        //     postAuthorImage: 'assets/img/user3.jpg',
        //     postAuthorName: 'David Warner'
        // }
    ];
}
class pageTitle {
    title: string;
}
class blogPostContent {
    postImg: string;
    postLink: string;
    postTitle: string;
    postSubTitle: string;
    postDate: string;
    postAuthorImage: string;
    postAuthorName: string;
}
